import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { factory as biLoggerFactory } from '@wix/fe-essentials-editor/bi';
const BI_PLATFORM_HOST_INTEGRATION_ENDPOINT = 'editor-platform';
const BI_PLATFORM_HOST_INTEGRATION_SRC = 164;
const PLATFORM_ERROR = 121;
export const biEventSteps = {
  start: 'start',
  end: 'end',
  error: 'error'
};
export class BI {
  constructor(options) {
    _defineProperty(this, "biLogger", void 0);
    this.biLogger = this.createBILogger(options);
  }
  createBILogger(options) {
    return biLoggerFactory({
      endpoint: BI_PLATFORM_HOST_INTEGRATION_ENDPOINT
    }).updateDefaults({
      src: BI_PLATFORM_HOST_INTEGRATION_SRC,
      msid: options.metaSiteId,
      uuid: options.userId,
      esi: options.editorSessionId,
      sdkVersion: options.sdkVersion,
      editorType: options.editorType
    }).logger();
  }
  createBiEvent(evid, event) {
    return {
      ...event,
      evid
    };
  }
  reportBi(event) {
    if (this.biLogger) {
      this.biLogger.log(event);
    }
  }
  reportError(event) {
    this.reportBi(this.createBiEvent(PLATFORM_ERROR, {
      appDefinitionId: event.appDefId || event.appDefinitionId,
      pageType: event.appType || event.pageType,
      errorMessage: event.error.toString(),
      errorDetails: event.error.stack,
      name: event.error.name,
      errorType: event.error.name,
      errorCode: event.error.code
    }));
  }
}
//# sourceMappingURL=BI.js.map